<template>
  <div class="modal_production_from_plan">
    <div class="modal_production_from_plan__header">
      <h4 class="title">
        {{ `${translate("specification.create_work_order")} ${device_sku}` }}
      </h4>
    </div>

    <div class="modal_production_from_plan__body">
      <div class="new_position">
        <div class="block">
          <div class="row">
            <div class="col-md-6 col-sm-6 input_wrap">
              <label>
                {{ translate('specification.user') }}
              </label>
              <tree-select
                  :options="company_user_list"
                  :placeholder="translate('specification.user')"
                  v-model="primary_data.user_id"
                  :clearable="false"
                  :multiple="false"
                  :searchable="true"
                  :max-height="200"
              />
            </div>

            <div class="col-md-6 col-sm-6 input_wrap">
              <label>
                {{ translate('specification.qty') }}
              </label>
              <tree-select
                  :options="qty_list"
                  :placeholder="translate('specification.qty')"
                  v-model="primary_data.count"
                  :clearable="false"
                  :multiple="false"
                  :searchable="true"
                  :max-height="200"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_production_from_plan__footer">
      <button
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="create_work_order"
          :disabled="primary_data.user_id === null || primary_data.count === null"
      >
        {{ translate('btn.create') }}
      </button>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

export default {
  name: 'ProductionFromPlanModal',
  props:{
    device_sku: {
      type: [String],
      required: true
    },
    max_qty: {
      type: [Number],
      required: true
    },
    client_order_spec_item_id: {
      type: [Number],
      required: true
    },
  },
  data () {
    return {
      primary_data: {
        count: null,
        user_id: null,
        client_order_spec_item_id: null
      },
    }
  },
  computed:{
    qty_list(){
      let qty_list = []
      for (let i = 1; i <= this.max_qty; i++) {
        qty_list.push({id: i, label: i})
      }
      return qty_list
    },
    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {label: user.name, id: user.id}
      })
    },
  },

  methods: {
    create_work_order(){
      this.primary_data.client_order_spec_item_id = this.client_order_spec_item_id
      this.$http.v1.workOrderSpecification(this.primary_data, (response) => {
        this.global_notify('info', this.translate('specification.saved_success'))
        this.$router.push({path: '/client_order/' + response.data.id})
        this.close_modal()
      })
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
.modal_production_from_plan{
  height: 100%;
  padding: 10px;
  &__header{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    .title{
      width: 100%;
      margin: 0;
      text-align: center;
    }
    .links{
      width: 30%;
      & > .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }
  &__body{
    width: 100%;
    height: 300px;
    .new_position{
      width: 100%;
      height: 100%;
      .block{
        padding: 10px;
        .row{
          margin-bottom: 10px;
        }
        .input_wrap,
        .text_wrap{
          text-align: start;
        }
        .form-group{
          margin-bottom: 0;
        }
      }
    }

  }
  &__footer{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    .btn{
      margin: 0 10px 0 0;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}

</style>
